import strtotime from 'locutus/php/datetime/strtotime'
import mktime from 'locutus/php/datetime/mktime'
import date from 'locutus/php/datetime/date'
import strftime from 'locutus/php/datetime/strftime'
import date_parse from 'locutus/php/datetime/date_parse'
import in_array from 'locutus/php/array/in_array'
import setlocale from 'locutus/php/strings/setlocale'

import time from 'locutus/php/datetime/time'
import { addDays, addMonths, differenceInDays, differenceInMonths  } from 'date-fns';

import Day from './includes/Models/Day'
import {Event} from './includes/Models/Event'
import EventCalendarRender from './organism/EventCalendarRender.js'
import {EventSync} from './includes/EventSync'
import EventListRender from './molecules/EventList/EventListRender'

class EventCalendar {
	constructor(base_calender, base_list) {
		this.base = base_calender
		this.base_list = base_list
		this.offset_init = 0
		this.active_dayitems = new Map()

		this.state = {};

		this.calender(this.offset_init)

		this.calenderbase_width = 0

		this.responsive()

		//show events from today
		this.calculate_list_and_render()
	}

	responsive() {
		let _this = this

		window.addEventListener("breakpointchanged", function(e) {
			_this.calender()
		}, false);
	}

	calender(offset = 0, length) {
		this.offset = offset
		//get current month display
		this.months = this.calculateCalendar(offset, length)

		//render calandar
		return this.renderCalendar().then((data) => {
			//this.events_of_the_day = this.calculate_list_and_render()

			//update month/days with drupal
			this.sync()
		});
	}

	sync() {
		const sync = new EventSync(this.current_filter)
		sync.fetch().then((data) => this.sync_excecute(data));
	}

	sync_excecute(data) {
		let events = {}
		events.raw = data.map(event => (new Event(event)))

		events.dates_has_events = this.build_events_list_for_storage(events.raw)

		//store date in local cache
		this.set_event_storage(events)

		//redraw calender
		this.renderCalendar()

		//on init render list
		const selector_list = document.body.querySelectorAll('.o-eventlistitem')
		if (!selector_list[0]) {
			this.calculate_list_and_render()
		}
	}

	set_event_storage(events) {
		let OrigStoredData = {}
		let _this = this

		const storedDataRaw = this.state.eventCalendar
		if (storedDataRaw) {
			OrigStoredData = this.state.eventCalendar
		} else {
			OrigStoredData.raw = []
			OrigStoredData.dates_has_events = []
		}

		//sync events details
		events.raw.forEach(function(value) {
			let is_inside = _this.nid_inside_raw(OrigStoredData.raw, parseInt(value.id))

			//add
			if (is_inside === false) {
				OrigStoredData.raw.push(value)
			}
		});

		//sync dates
		events.dates_has_events.forEach(function(value) {
			let is_inside = in_array(value, OrigStoredData.dates_has_events)

			if (is_inside === false) {
				OrigStoredData.dates_has_events.push(value)
			}
		});

		this.state.eventCalendar = OrigStoredData;
	}

	getDaysArray(start_orig, end) {
		//clone start
		let start = new Date(start_orig)

		for (var arr = [], dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
			let dumpdate = new Date(dt)
			arr.push(date_parse(dumpdate.toDateString()));
		}
		return arr;
	};

	nid_inside_raw(OrigStoredData, nid) {
		for (const value of OrigStoredData) {
			if (parseInt(value.id) === nid) {
				return true
			}
		}

		return false
	}

	build_events_list_for_storage(data) {
		return data.flatMap(event => {
			return this.getDaysArray(event.dateobj, event.end_dateobj).map(day => {
				return day.year + '-' + this.addnull(day.month) + '-' + this.addnull(day.day)
			})
		})
	}

	addnull(string) {
		if (parseInt(string) < 10) {
			string = '0' + String(string)
		}

		return string
	}

	daterange_between() {
		return (startD >= startdate && startD <= enddate) ||
			(startdate >= startD && startdate <= endD);
	}

	date_between() {
		return (startD >= startdate && startD <= enddate) ||
			(startdate >= startD && startdate <= endD);
	}

	getTimestamp(dateObject) {
		return mktime(0, 0, 0, date('m', dateObject), date('d', dateObject), date('Y', dateObject));
	}

	pushSpecificEvents(OrigStoredData, strict_date) {
		//only date of the day
		OrigStoredData.raw.map(event => {
			//monat tag jahr
			const start_ts = this.getTimestamp(event.ts + event.timezone)
			const end_ts = this.getTimestamp(event.end_ts + event.timezone)

			if ((strict_date >= start_ts) && (strict_date <= end_ts)) {
				//render event
				this.events.push(event)
			}
		})
	}

	pushEvents(OrigStoredData) {
		//today
		const now = strtotime('+' + this.offset + ' day', mktime(0, 0, 0))
		const dates_with_events = new Map();

		//next events nearest today
		OrigStoredData.raw.map(event => {
			const start_ts = this.getTimestamp(event.ts)
			const end_ts = this.getTimestamp(event.end_ts)

			if ((now <= start_ts) || (now <= end_ts)) {

				if ((event.ts >= now) && (start_ts === end_ts)) {
					const datestring = date('Y',event.ts) + date('m',event.ts) + date('d',event.ts)
					this.push_to_date_by_day_map(dates_with_events, datestring, event)
				}

				//if end differnt to start
				if (start_ts !== end_ts) {
					//range
					const ranges = this.getDatesBetween(new Date(event.dateobj), new Date(event.end_dateobj))

					ranges.forEach(range => {
						const range_ts = range.getTime() / 1000

						if (range_ts >= now) {
							const datestring = `${range.getFullYear()}${this.addnull(range.getMonth()+1)}${this.addnull(range.getDate())}`
							this.push_to_date_by_day_map(dates_with_events, datestring,event);
						}
					})
				}
			}
		})

		//sort by datestring (nearliest first)
		const dates_with_events_ordered = new Map([...dates_with_events.entries()].sort());
		//get current
		const events_of_day = dates_with_events_ordered.values().next().value;

		if (events_of_day) {
			events_of_day.sort((a, b) => a.ts - b.ts);

			events_of_day.forEach(event => {
				this.events.push(event)
			})

			//mark first calendar item
			this.active_dayitems.set(date('Y-m-d', events_of_day[0].ts) , true)
		}
	}

	calculate_list_and_render(strict_date = null) {
		let OrigStoredData = {}
		const storedDataRaw = this.state.eventCalendar;
		if (storedDataRaw) {
			OrigStoredData = storedDataRaw
		} else {
			OrigStoredData.raw = []
			OrigStoredData.dates_has_events = []
		}

		this.events = []

		if (strict_date) {
			this.pushSpecificEvents(OrigStoredData, strict_date);
			this.events.sort((a, b) => a.ts - b.ts);
		} else {
			this.pushEvents(OrigStoredData);
		}

		this.renderList()
	}

	push_to_date_by_day_map(dates_with_events, datestring, event) {
		let dump = dates_with_events.get(datestring)
		if (!dump) {
			dump = []
		}

		dump.push(event)
		dates_with_events.set(datestring, dump);
	}

	getDatesBetween(startDate, endDate) {
		const days = differenceInDays(endDate, startDate);

		return [...Array(days+1).keys()].map((i) => addDays(startDate, i));
	};

	calculateCalendar(offset, length) {
		if (!offset) {
			offset = 0
		}

		if (!length) {
			length = this.get_number_of_max_items()
		}

		const months = []

		let date_array = new Map

		this.today = strtotime('+' + offset + ' day', mktime(0, 0, 0))

		if (!this.todaybase) {
			this.todaybase = this.today
		}

		let length_final = length + 30
		let last = strtotime('+' + length_final + ' day', this.today)

		let first = strtotime('-6 week', this.today)

		//need for graph filter
		this.current_filter = [date('Ymd', first), date('Ymd', last)]

		//let today = new Date / 1E3 | 0;

		let month_cnt = 0

		for (let i = 1; i < length; i++) {
			let ts = strtotime('+' + i + ' day', this.today)

			this.setlocale()
			let fmt = '%B'

			var mybreakpoints = breakpoints.match();
			if (mybreakpoints.indexOf('bp-mobile') > -1) {
				fmt = '%b'
			}
			let month = strftime(fmt, ts);
			let day = new Day(ts)

			let current_month = date_array.get(month)

			if (!current_month) {
				current_month = new Map()
				current_month.set('month', month)
				current_month.set('days', [])

				month_cnt++

				if (month_cnt > 1) {
					//length--
				}
			}

			current_month.get('days').push(day)
			date_array.set(month, current_month)
		}

		date_array.forEach(function(item) {
			months.push({
				name: item.get('month'),
				days: item.get('days')
			})
		})

		return months
	}

	setlocale() {
		var $global = typeof window !== 'undefined' ? window : global;
		$global.$locutus = $global.$locutus || {};
		var $locutus = $global.$locutus;
		$locutus.php = $locutus.php || {};

		if (!$locutus.php.locales) {
			setlocale('LC_ALL', 'en')
		}

		if ($locutus.php.locales) {
			//add
			$locutus.php.locales.de_DE = $locutus.php.locales.en
			$locutus.php.locales.de_DE.LC_TIME.a = ['So','Mo','Di', 'Mi', 'Do', 'Fr', 'Sa']
			$locutus.php.locales.de_DE.LC_TIME.b = ['Jan','Feb','Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov','Dez']
			$locutus.php.locales.de_DE.LC_TIME.B = ['Januar','Februar','März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November','Dezember']

			setlocale('LC_ALL', 'de_DE')
		}
	}

	get_number_of_max_items() {
		//change number of date icons for every breakpoint or free space
		var mybreakpoints = breakpoints.match();
		if (mybreakpoints.indexOf('bp-mobile') > -1) {
			return 7;
		}
		if (mybreakpoints.indexOf('bp-tablet') > -1) {
			if (window.breakpoints.is_landscape() === true) {
				return 15
			}

			return 11
		}

		return 13
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.visible !== this.props.visible) {
			if (nextProps.visible) {
				$(findDOMNode(this)).stop(true, true).fadeIn('slow');
			} else {
				$(findDOMNode(this)).stop(true, true).fadeOut('slow');
			}
		}
	}

	renderCalendar() {
		return new Promise((resolve, reject) => {
			try {
				ReactDOM.render((<EventCalendarRender
						eventCalendar={this.state.eventCalendar}
						months={this.months}
						element={this.base}
						controller={this}
					/>), this.base, function() {
						resolve(this);
					}
				);
			} catch (e) {
				reject(e);
			}
		});
	}

	renderList() {
		ReactDOM.render((<EventListRender
			events={this.events}
			element={this.base_list}
			controller={this}
		/>), this.base_list);
	}
}

export { EventCalendar };
